<template>
  <div class="wrapper">
    <page-banner></page-banner>
    <div class="main">
      <div class="breadcrumb">
        <svg t="1702547791177" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1445" width="64" height="64"><path d="M512 341.333333L170.666667 512v455.111111h398.222222v-227.555555h113.777778v227.555555h170.666666V512L512 341.333333z" fill="#515151" p-id="1446"></path><path d="M910.222222 306.631111V113.777778h-113.777778v129.706666L512 85.333333l-512 284.444445L51.2 455.111111 512 204.8l460.8 256 51.2-91.022222-113.777778-63.146667z" fill="#515151" p-id="1447"></path></svg>
        <span class="clickable" @click="goToHome">官网首页</span>
        <span>&gt;</span>
        <span>新闻列表</span>
      </div>
      <div class="title"></div>
      <div class="tab-list">
        <div class="tab">
          <div
            v-for="(item, key) in typeList"
            :key="key"
            class="tab-item"
            :class="getTabClass(key, item)"
            @click="changeTab(item)"
          >
            <div class="image"></div>
            <div class="tab-seperator" v-if="key != typeList.length - 1"></div>
          </div>
        </div>
        <div class="list">
          <template v-if="newsList.length > 0">
            <div
              v-for="(item, key) in newsList"
              :key="key"
              class="list-item"
              @click="openDetailPage(item)"
            >
              <div class="content">
                <div class="left">
                  <div class="tag">{{ item.tag }}</div>
                </div>
                <div class="right">
                  <div class="top">
                    <span>{{ item.time }}</span>
                    <span>{{ item.title }}</span>
                  </div>
                  <div class="bottom">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="empty">暂无数据</div>
          </template>
        </div>
      </div>
      <pagination :startHeight="440" :total="total" :pageNum="currentPage" @change="changePage" v-if="newsList.length > 0" />
    </div>
    <module-footer></module-footer>
  </div>
</template>

<script>
import PageBanner from '../components/pageBanner'
import ModuleFooter from '../components/footer'
import Pagination from './components/pagination'

import { getNewsList } from '@/api/system.api.js'

export default {
  components: {
    PageBanner,
    ModuleFooter,
    Pagination,
  },
  data() {
    return {
      newsList: [],
      total: 0,
      currentPage: 1,
      activeTab: 'last',
      typeList: ['last', 'news', 'strategy', 'activity'],
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    this.getNewsList()
  },
  methods: {
    getNewsList() {
      getNewsList({
        page: this.currentPage,
        limit: 10,
      }, this.activeTab)
        .then((res) => {
          let list = []
          for (let i = 0; i < res.list.length; i++) {
            list.push({
              id: res.list[i].id,
              tag: res.list[i].tag,
              title: res.list[i].title,
              time: new Date(res.list[i].createtime * 1000).toLocaleDateString('zh-cn'),
              description: res.list[i].desc,
            })
          }

          this.newsList = list
          this.total = res.total
        })
    },
    // 获取当前选中的新闻类型的className
    getTabClass(key, item) {
      let className = 'tab-type-' + item

      return className + (this.activeTab == item ? ' tab--active' : '')
    },
    // 切换分类
    changeTab(key) {
      this.activeTab = key
      this.currentPage = 1
      this.getNewsList()
    },
    // 回到首页
    goToHome() {
      this.$router.push({ name: 'Home' })
    },
    // 切换页码
    changePage(page) {
      this.currentPage = page
      this.getNewsList()
    },
    openDetailPage(item) {
      this.$router.push({ name: 'Detail', query: { id: item.id } })
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  max-width: 1920px;
  min-width: 1600px;
  width: 100%;
  background: #e2f3fb;
}

.title {
  margin: 20px auto 0;
  width: 1600px;
  height: 177px;
  background: url('~@/assets/img/page_title.png') no-repeat;
}

.main {
  padding-bottom: 198px;
  min-height: calc(100vh - 613px);
}

.breadcrumb {
  display: flex;
  margin: 21px auto 0;
  width: 1000px;
  font-size: 16px;
  color: #515151;

  svg {
    margin-right: 8px;
    width: 24px;
    height: 24px;
  }

  span {
    margin-right: 6px;
  }

  .clickable {
    cursor: pointer;
  }
}

.tab-list {
  .tab {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin: 48px auto 10px;
    width: 393px;

    &-item {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      cursor: pointer;

      .image {
        width: 90px;
        height: 48px;
        background: url('~@/assets/img/list_title.png') no-repeat;
      }
    }

    &--active {
      background: url('~@/assets/img/bg_title.png') no-repeat;
      background-position: left bottom;
    }

    &-seperator {
      margin: 8px 0 0 4px;
      width: 9px;
      height: 9px;
      background: url('~@/assets/img/title_dot.png') no-repeat;
    }

    &-type {
      &-last .image {
        background-position: 0 0;
      }
      &-news .image {
        background-position: -90px 0;
      }
      &-strategy .image {
        background-position: 0 -46px;
      }
      &-activity .image {
        background-position: -90px -46px;
      }
    }
  }
}

.list {
  margin-bottom: 100px;
  width: 100%;
  min-height: 500px;
  border-top: 1px solid #959595;

  &-item {
    border-bottom: 1px solid #fff;
    cursor: pointer;

    .content {
      display: flex;
      margin: 0 auto;
      padding-top: 50px;
      width: 1000px;
      height: 152px;
    }

    .left {
      margin-right: 35px;

      .tag {
        width: 62px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 20px;
        color: #fff;
        background: #0155a5 ;
      }
    }

    .right {
      display: flex;
      flex-direction: column;
      width: 854px;

      .top {
        display: flex;
        align-items: center;
        margin-bottom: 7px;
        height: 32px;
        font-size: 20px;
        font-weight: bold;
        color: #3a3a3a;

        span:first-of-type {
          margin-right: 25px;
          width: 110px;
        }

        span:last-of-type {
          flex: 1;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .bottom {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #8e8e8e;
      }
    }

    &:hover {
      background: url('~@/assets/img/bg_list.jpg') no-repeat;

      .bottom {
        color: #3a3a3a;
      }
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    font-size: 30px;
    color: #3a3a3a;
  }
}
</style>